<template>
  <v-container fluid pa-0>
    <v-row align="center" class="mb-5" justify="center">
      <v-progress-circular :value="current" rotate="270" size="92" width="1">
        <div style="width: 92px; height: 92px; border-radius: 50%; background-color: rgba(255,255,255,0.2)">
          <v-row align="center" class="fill-height" justify="center">
            <v-icon size="68" style="margin: auto;">mdi-pause</v-icon>
          </v-row>
        </div>
      </v-progress-circular>
    </v-row>
    <v-row align="center" class="mb-5" justify="center" style="user-select: none;">
                   <span class="display-1 font-weight-light">
                        {{$t('pause.title')}}
                    </span>
    </v-row>
    <v-row justify="center" style="max-width: 700px;">
      <div class="text-center">
        {{$t('pause.description')}}
      </div>
    </v-row>
    <v-row align="center" class="mt-5" justify="center">
      <v-btn @click="takeBreak()"
             class="ma-1"
             color="grey"
             large
      >{{$t('pause.break')}}
      </v-btn>
      <v-btn @click="quit()"
             class="ma-1"
             color="accent"
             large
      >{{$t('pause.quit')}}
      </v-btn>
      <v-btn @click="setResumeState()"
             class="ma-1"
             color="secondary"
             large
      >{{$t('pause.resume')}}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
    export default {
        name: "PausedState",
        props: {
            time: {
                type: Number
            },
            interval: {
                type: Number
            }
        },
        data: () => ({
            current: 0,
        }),
        methods: {
            setResumeState() {
                this.$emit('resume',true);
            },
            takeBreak() {
              this.$emit('break', true);
            },
            quit() {
              this.$emit('quit', true);
            }
        },
        mounted() {
            let increment = (100 / (this.time * 60)) / 4;
            this._counter = setInterval(() => {
                this.current += increment;
            }, 250);
            setTimeout(() => {
                this.$emit('break', true);
            }, (this.time * 60000) + 1000);
        },
        beforeDestroy() {
            clearInterval(this._counter);
        }
    }
</script>

<style scoped>

</style>
